import React, { useEffect, useState } from "react";
import "../css/Crm.css";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ContactsIcon from "@mui/icons-material/Contacts";
import HandshakeIcon from "@mui/icons-material/Handshake";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import Faq from "../Common/Faq";


function Crm() {
  
  

  return (
    <>
      <Header />

      {/* top section */}
      <div className="crm-container-top">
        <div className="common-container">
          <div className="crm-top-left">
            <h2>Your All-in-One CRM to Grow Relationships & Revenue</h2>
            <p>
              Manage leads, track interactions, close deals, and build lasting
              customer relationships — all from one powerful, easy-to-use CRM
              platform.
            </p>

            <div className="crm-top-box-container">
              <div className="crm-top-box">
                <LeaderboardIcon style={{ fontSize: 40 }} />
                <h2>Leads</h2>
              </div>
              <div className="crm-top-box">
                <ContactsIcon style={{ fontSize: 40 }} />
                <h2>Contacts</h2>
              </div>
              <div className="crm-top-box">
                <HandshakeIcon style={{ fontSize: 40 }} />
                <h2>Deals</h2>
              </div>
              <div className="crm-top-box">
                <ConfirmationNumberIcon style={{ fontSize: 40 }} />
                <h2>Tickets</h2>
              </div>
            </div>

            <div className="crm-top-btn">
              <button>
                Get Started Now{" "}
                <ArrowForwardIosIcon style={{ fontSize: 16, marginLeft: 8 }} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Feature-section */}
      <div className="crm-feature-container">
        <h2> Streamline Support with Smart Ticket Management</h2>
        <div className="crm-feature-content">
          <div className="crm-feature-left">
            <h3>Features of Task Management</h3>
            <div className="crm-feature-box-container">
              <div className="crm-feature-box">
                <p>✅ Create and assign tasks</p>
              </div>
              <div className="crm-feature-box">
                <p>⏰ Set due dates and reminders</p>
              </div>
              <div className="crm-feature-box">
                <p>🏷️ Prioritize tasks</p>
              </div>
              <div className="crm-feature-box">
                <p>🔄 Track task progress</p>
              </div>
              <div className="crm-feature-box">
                <p>👥 Collaborate with your team</p>
              </div>
              <div className="crm-feature-box">
                <p>📆 Integrate with calendars</p>
              </div>
              <div className="crm-feature-box">
                <p>📲 Get notified instantly</p>
              </div>
              <div className="crm-feature-box">
                <p>📊 Monitor productivity</p>
              </div>
            </div>
          </div>
          <div className="crm-feature-right">
            <img src="./images/crm-task1.png" alt="crm-image" />
            <img src="./images/crm-task2.png" alt="crm-image" />
          </div>
        </div>
      </div>

      {/* Management-section */}
      <div className="crm-management-container">
        <h2> Powerful Contact Management Made Easy</h2>
        <div className="crm-management-content">
            <h3>Super Easy Contact Management</h3>
            <div className="crm-management-box-container">
              <div className="crm-management-box">
                <h3>🎯 Assign Tasks or Tickets to Contacts</h3>
                <p>
                  Easily connect contacts with relevant tasks or support tickets
                  to maintain clear ownership and accountability. Whether it's a
                  follow-up call, a product demo, or a customer issue,
                  everything is tracked directly under the contact’s profile.
                  This ensures no communication gets lost and your team always
                  knows who’s responsible for what.
                </p>
              </div>

              <div className="crm-management-box">
                <h3>🔐 Control Permissions and Access</h3>
                <p>
                  Give contacts customized access to specific areas of your
                  platform, such as client portals, updates, or shared files.
                  You can define permission levels based on roles — for example,
                  allowing some contacts to view support tickets while
                  restricting others to read-only access.
                </p>
              </div>

              <div className="crm-management-box">
                <h3>🔗 Link Contacts to Companies, Deals etc</h3>
                <p>
                  Associate each contact with their respective company, active
                  deals, or automated workflows for full context in every
                  interaction. This relationship mapping helps your team
                  understand who the contact is, what stage they’re in, and what
                  needs to be done next.
                </p>
              </div>
            </div>
          </div>
        </div>


      {/* ticket-section */}
      <div className="crm-ticket-container">
        <h2> Streamline Support with Smart Ticket Management</h2>
        <div className="crm-ticket-content">
          <div className="crm-ticket-left">
            <h3>Simplify Support Tickets</h3>
            <p>
              Deliver fast, organized, and efficient customer support with a
              powerful ticketing system built right into your CRM. Easily
              create, assign, and track support tickets linked to specific
              contacts, companies, or issues. Prioritize and categorize incoming
              requests, set SLAs, and monitor resolution progress in real-time.
              With clear visibility, team collaboration, and status updates,
              your support teams can resolve queries faster — ensuring customer
              satisfaction every step of the way.
            </p>
          </div>
          <div className="crm-ticket-right">
            <img src="./images/support-ticket.png" alt="crm-image" />
          </div>
        </div>
      </div>


        {/* deals-section */}
      <div className="crm-deals-container">
        <h2> Streamline Support with Smart Ticket Management</h2>
        <div className="crm-deals-content">
             <div className="crm-deals-right">
            <img src="./images/crm-deals.png" alt="crm-image" />
          </div>
          <div className="crm-deals-left">
            <h3>Simplify Support Tickets</h3>
            <p>
              Deliver fast, organized, and efficient customer support with a
              powerful ticketing system built right into your CRM. Easily
              create, assign, and track support tickets linked to specific
              contacts, companies, or issues. Prioritize and categorize incoming
              requests, set SLAs, and monitor resolution progress in real-time.
              With clear visibility, team collaboration, and status updates,
              your support teams can resolve queries faster — ensuring customer
              satisfaction every step of the way.
            </p>
          </div>
         
        </div>
      </div>




            <Faq
        endpoint="/api/faq/GetFaqList" // only endpoint, domain comes from .env
        params={{
          currentPage: 1,
          pageSize: 20,
          sortColumn: "FaqId",
          sortDirection: "asc",
          category: "CRM Issues"  
        }}
      />




      <Footer />
    </>
  );
}

      
  

export default Crm;
